import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Separator } from "./ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import {
    User,
    Lock,
    Mail,
    UserPlus,
    Loader2,
    Container,
    Box,
    Key,
} from "lucide-react";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { InvitationCode } from '../types/invitation-code';
import { InvitationGate } from './InvitationGate';


// Social provider configurations
const socialProviders = [
    {
        id: 'google',
        name: 'Google',
        icon: (
            <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
        ),
        className: 'border-gray-300 hover:bg-gray-50 text-gray-700'
    },
    // {
    //     id: 'github',
    //     name: 'GitHub',
    //     icon: (
    //         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //             <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    //         </svg>
    //     ),
    //     className: 'border-gray-800 hover:bg-gray-800 text-gray-800 hover:text-white'
    // },
    // {
    //     id: 'apple',
    //     name: 'Apple',
    //     icon: (
    //         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //             <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    //         </svg>
    //     ),
    //     className: 'border-gray-800 hover:bg-gray-800 text-gray-800 hover:text-white'
    // },
    // {
    //     id: 'discord',
    //     name: 'Discord',
    //     icon: (
    //         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //             <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0188 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z" />
    //         </svg>
    //     ),
    //     className: 'border-[#5865F2] hover:bg-[#5865F2] text-[#5865F2] hover:text-white'
    // }
];

export function AuthPage() {
    const { signup, login, isAuthenticated, loading, loginWithGoogle, signupWithGoogle } = useAuth();
    const [validatedCode, setValidatedCode] = useState<InvitationCode | null>(null);
    const [showSignup, setShowSignup] = useState(false);
    const navigate = useNavigate();

    // env var for beta mode
    const betaMode = process.env.REACT_APP_BETA_MODE === 'true';

    useEffect(() => {
        if (!betaMode) {
            // if not in beta mode, auto-show signup
            setShowSignup(true);
        }
    }, [betaMode]);


    const [loginForm, setLoginForm] = useState({
        email: '',
        password: ''
    });

    const [signupForm, setSignupForm] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        invitationCode: '',
    });

    const [loadingProvider, setLoadingProvider] = useState<string | null>(null);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await login(loginForm.email, loginForm.password);
            navigate('/explore');
        } catch (error) {
            console.error('Login failed:', error);
            toast.error('Invalid email or password');
        };
    };

    const handleSignup = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!signupForm.invitationCode) {
            toast.error('Invitation code is required');
            return;
        }

        if (signupForm.password !== signupForm.confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        if (signupForm.name && signupForm.email && signupForm.password) {
            try {
                await signup(
                    {
                        email: signupForm.email,
                        password: signupForm.password,
                        name: signupForm.name,
                        invitationCodeId: validatedCode?.id
                    }
                );
                toast.success('Account created successfully');
                navigate('/login');
            } catch (error: any) {
                toast.error(`Account creation failed: ${error.message}`);
            }
        } else {
            toast.error('Name, email, password, confirm password and invitation code are required');
        }
    };

    const handleSocialLogin = async (providerId: string) => {
        setLoadingProvider(providerId);

        if (providerId === 'google') {
            await loginWithGoogle();
        }

        // Simulate OAuth flow
        await new Promise(resolve => setTimeout(resolve, 2000));

        // In a real app, this would redirect to the OAuth provider
        console.log(`Authenticating with ${providerId}`);

        setLoadingProvider(null);

    };

    const handleSocialSignup = async (providerId: string) => {
        if (!betaMode) {
            toast.error('Invitation code is required during beta');
            return;
        }

        if (validatedCode) {
            sessionStorage.setItem('invitationCodeId', validatedCode.id);
        }

        setLoadingProvider(providerId);
        if (providerId === 'google') {
            await signupWithGoogle();
        }

        // Simulate OAuth flow
        await new Promise(resolve => setTimeout(resolve, 2000));

        // In a real app, this would redirect to the OAuth provider
        console.log(`Signing up with ${providerId}`);
        setLoadingProvider(null);

    };

    const renderSocialLoginButton = (provider: typeof socialProviders[0]) => (
        <Button
            key={provider.id}
            variant="outline"
            onClick={() => handleSocialLogin(provider.id)}
            disabled={loadingProvider !== null}
            className={`w-full justify-center items-center space-x-3 h-11 transition-colors ${provider.className}`}
        >
            {loadingProvider === provider.id ? (
                <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
                provider.icon
            )}
            <span>Login with {provider.name}</span>
        </Button>
    );

    const renderSocialSignupButton = (provider: typeof socialProviders[0]) => (
        <Button
            key={provider.id}
            variant="outline"
            onClick={() => handleSocialSignup(provider.id)}
            disabled={loadingProvider !== null}
            className={`w-full justify-center items-center space-x-3 h-11 transition-colors ${provider.className}`}
        >
            {loadingProvider === provider.id ? (
                <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
                provider.icon
            )}
            <span>Signup with {provider.name}</span>
        </Button>
    );

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold mb-2">PlayHub</h1>
                    <p className="text-muted-foreground">
                        Join activities and connect with others
                    </p>
                </div>

                <Tabs defaultValue="login" className="w-full">
                    <TabsList className="grid w-full grid-cols-2">
                        <TabsTrigger value="login">Login</TabsTrigger>
                        <TabsTrigger value="signup">Sign Up</TabsTrigger>
                    </TabsList>

                    <TabsContent value="login">
                        <Card>
                            <CardHeader>
                                <CardTitle className="flex items-center space-x-2">
                                    <User size={20} />
                                    <span>Welcome Back</span>
                                </CardTitle>
                            </CardHeader>
                            <CardContent className="space-y-4">
                                {/* Social Login Buttons */}
                                <div className="space-y-3">
                                    {socialProviders.map(renderSocialLoginButton)}
                                </div>

                                <div className="relative">
                                    <div className="absolute inset-0 flex items-center">
                                        <Separator className="w-full" />
                                    </div>
                                    <div className="relative flex justify-center text-xs uppercase">
                                        <span className="bg-background px-2 text-muted-foreground">
                                            Or continue with email
                                        </span>
                                    </div>
                                </div>

                                <form onSubmit={handleLogin} className="space-y-4">
                                    <div>
                                        <Label htmlFor="login-email">Email</Label>
                                        <div className="relative">
                                            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                            <Input
                                                id="login-email"
                                                type="email"
                                                placeholder="Enter your email"
                                                value={loginForm.email}
                                                onChange={(e) => setLoginForm(prev => ({ ...prev, email: e.target.value }))}
                                                className="pl-10"
                                                required
                                                disabled={loading || loadingProvider !== null}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <Label htmlFor="login-password">Password</Label>
                                        <div className="relative">
                                            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                            <Input
                                                id="login-password"
                                                type="password"
                                                minLength={6}
                                                maxLength={128}
                                                placeholder="Enter your password"
                                                value={loginForm.password}
                                                onChange={(e) => setLoginForm(prev => ({ ...prev, password: e.target.value }))}
                                                className="pl-10"
                                                required
                                                disabled={loading || loadingProvider !== null}
                                            />
                                        </div>
                                    </div>

                                    <Button
                                        type="submit"
                                        className="w-full"
                                        disabled={loading || loadingProvider !== null}
                                    >
                                        {loading ? (
                                            <>
                                                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                                Signing In...
                                            </>
                                        ) : (
                                            'Sign In'
                                        )}
                                    </Button>
                                </form>

                                <div className="text-center">
                                    <button
                                        className="text-sm text-primary hover:underline"
                                        disabled={loading || loadingProvider !== null}
                                    >
                                        Forgot your password?
                                    </button>
                                </div>
                            </CardContent>
                        </Card>
                    </TabsContent>

                    <TabsContent value="signup">
                        {betaMode && !showSignup && true ? (
                            <InvitationGate
                                onValidated={(codeInfo) => {
                                    setValidatedCode({ id: codeInfo.codeId, code: codeInfo.code });
                                    setShowSignup(true);
                                }}
                            />
                        ) : (
                            <Card>
                                <CardHeader>
                                    <CardTitle className="flex items-center space-x-2">
                                        <UserPlus size={20} />
                                        <span>Create Account</span>
                                    </CardTitle>
                                </CardHeader>
                                <CardContent className="space-y-4">
                                    {/* Social Login Buttons */}
                                    <div className="space-y-3">
                                        {socialProviders.map(renderSocialSignupButton)}
                                    </div>

                                    <div className="relative">
                                        <div className="absolute inset-0 flex items-center">
                                            <Separator className="w-full" />
                                        </div>
                                        <div className="relative flex justify-center text-xs uppercase">
                                            <span className="bg-background px-2 text-muted-foreground">
                                                Or create account with email
                                            </span>
                                        </div>
                                    </div>

                                    <form onSubmit={handleSignup} className="space-y-4">
                                        <div>
                                            <Label htmlFor="signup-name">Full Name</Label>
                                            <div className="relative">
                                                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                                <Input
                                                    id="signup-name"
                                                    type="text"
                                                    placeholder="Enter your full name"
                                                    value={signupForm.name}
                                                    onChange={(e) => setSignupForm(prev => ({ ...prev, name: e.target.value }))}
                                                    className="pl-10"
                                                    required
                                                    disabled={loading || loadingProvider !== null}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Label htmlFor="signup-email">Email</Label>
                                            <div className="relative">
                                                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                                <Input
                                                    id="signup-email"
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    value={signupForm.email}
                                                    onChange={(e) => setSignupForm(prev => ({ ...prev, email: e.target.value }))}
                                                    className="pl-10"
                                                    required
                                                    disabled={loading || loadingProvider !== null}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Label htmlFor="signup-password">Password</Label>
                                            <div className="relative">
                                                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                                <Input
                                                    id="signup-password"
                                                    type="password"
                                                    minLength={6}
                                                    maxLength={128}
                                                    placeholder="Create a password, at least 6 characters"
                                                    value={signupForm.password}
                                                    onChange={(e) => setSignupForm(prev => ({ ...prev, password: e.target.value }))}
                                                    className="pl-10"
                                                    required
                                                    disabled={loading || loadingProvider !== null}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Label htmlFor="signup-confirm">Confirm Password</Label>
                                            <div className="relative">
                                                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                                <Input
                                                    id="signup-confirm"
                                                    type="password"
                                                    minLength={6}
                                                    maxLength={128}
                                                    placeholder="Confirm your password, same as above"
                                                    value={signupForm.confirmPassword}
                                                    onChange={(e) => setSignupForm(prev => ({ ...prev, confirmPassword: e.target.value }))}
                                                    className="pl-10"
                                                    required
                                                    disabled={loading || loadingProvider !== null}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Label htmlFor="signup-invitation-code">Invitation Code</Label>
                                            <div className="relative">
                                                <Key className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={16} />
                                                <Input
                                                    id="signup-invitation-code"
                                                    type="text"
                                                    placeholder="Enter your invitation code"
                                                    value={signupForm.invitationCode}
                                                    onChange={(e) => setSignupForm(prev => ({ ...prev, invitationCode: e.target.value }))}
                                                    className="pl-10"
                                                    required
                                                    disabled={loading || loadingProvider !== null}
                                                />
                                            </div>
                                        </div>

                                        <Button
                                            type="submit"
                                            className="w-full"
                                            disabled={loading || loadingProvider !== null}
                                        >
                                            {loading ? (
                                                <>
                                                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                                    Creating Account...
                                                </>
                                            ) : (
                                                'Create Account'
                                            )}
                                        </Button>
                                    </form>

                                    <div className="text-xs text-center text-muted-foreground">
                                        By creating an account, you agree to our{' '}
                                        <button className="text-primary hover:underline">Terms of Service</button>
                                        {' '}and{' '}
                                        <button className="text-primary hover:underline">Privacy Policy</button>
                                    </div>
                                </CardContent>
                            </Card>
                        )}
                    </TabsContent>
                </Tabs>

                {/* <div className="mt-6 text-center text-sm text-muted-foreground">
                    <p>Demo: Use any email and password to login</p>
                </div> */}
            </div>
        </div>
    );
}
